import GenelorUsersManager from './GenelorUsersManager';
import React, { useState } from "react";
import AmsUsersManager from "./AmsUsersManager";
import MbjUsersManager from "./MbjUsersManager";
import IsolacierUsersManager from "./IsolacierUsersManager";
import HrtpUsersManager from "./HrtpUsersManager";
import EhvUsersManager from "./EhvUsersManager";
import "./UsersManager.css";

export default function UsersManager({ currentUser }) {
  const [system, setSystem] = useState("ams");

  return (
    <div className="um-system-shell">
      <nav className="um-system-tabs" aria-label="Entreprise à administrer">
        <button
          type="button"
          className={system === "ams" ? "active" : ""}
          onClick={() => setSystem("ams")}
        >
          AM Services
        </button>
        <button
          type="button"
          className={system === "mbj" ? "active mbj" : ""}
          onClick={() => setSystem("mbj")}
        >
          MBJ
        </button>
        <button
          type="button"
          className={system === "isolacier" ? "active isolacier" : ""}
          onClick={() => setSystem("isolacier")}
        >
          Isolacier
        </button>
        <button
          type="button"
          className={system === "hrtp" ? "active hrtp" : ""}
          onClick={() => setSystem("hrtp")}
        >
          HRTP
        </button>
        <button
          type="button"
          className={system === "ehv" ? "active ehv" : ""}
          onClick={() => setSystem("ehv")}
        >
          EHV
        </button>
        <button type="button" className={system === "genelor" ? "active" : ""} onClick={() => setSystem("genelor")}>Genelor</button>
      </nav>

      {system === "genelor" && <GenelorUsersManager currentUser={currentUser} />}
      {system === "ams" && <AmsUsersManager currentUser={currentUser} />}
      {system === "mbj" && <MbjUsersManager currentUser={currentUser} />}
      {system === "isolacier" && <IsolacierUsersManager currentUser={currentUser} />}
      {system === "hrtp" && <HrtpUsersManager currentUser={currentUser} />}
      {system === "ehv" && <EhvUsersManager currentUser={currentUser} />}
    </div>
  );
}
